export const _SUCCESS = "_SUCCESS";
export const _FAILURE = "_FAILURE";
export const FETCH_DOCTOR_DOCUMENTS_REQUEST = "FETCH_DOCTOR_DOCUMENTS_REQUEST";
export const ADD_DOCTOR_DOCUMENT_REQUEST = "ADD_DOCTOR_DOCUMENT_REQUEST";
export const DELETE_DOCTOR_DOCUMENT_REQUEST = "DELETE_DOCTOR_DOCUMENT_REQUEST";
export const DOWNLOAD_DOCTOR_DOCUMENT_REQUEST = "DOWNLOAD_DOCTOR_DOCUMENT_REQUEST";
